module.exports = __webpack_public_path__ + "static/media/office_equipment.372d4660.png";